import { ReactNode } from 'react';

export interface ITab {
  id: string;
  label: string;
  content: ReactNode;
}

export interface ITabsProps {
  tabs: ITab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  rightContent?: ReactNode;
}

export function Tabs({ tabs, activeTab, onTabChange, rightContent }: ITabsProps) {
  return (
    <div className="w-full h-full bg-background flex flex-col border-t border-border">
      <div className="flex items-center border-b border-border bg-card">
        <div className="flex">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`
                px-4 py-2 font-mono text-sm border-none cursor-pointer transition-colors flex items-center gap-2
                ${activeTab === tab.id
                  ? 'bg-background text-foreground border-b-2 border-primary'
                  : 'bg-card text-muted-foreground hover:text-foreground hover:bg-muted'
                }
              `}
            >
              {activeTab === tab.id && (
                <span className="w-1.5 h-1.5 rounded-full bg-primary"></span>
              )}
              {tab.label}
            </button>
          ))}
        </div>
        {rightContent && (
          <div className="ml-auto pr-2">
            {rightContent}
          </div>
        )}
      </div>
      <div className="flex-1 overflow-hidden">
        {tabs.map((tab) => (
          <div
            key={tab.id}
            className={`w-full h-full ${activeTab === tab.id ? 'block' : 'hidden'}`}
          >
            {tab.content}
          </div>
        ))}
      </div>
    </div>
  );
}
